var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { OfficeProductAssignmentLiteDto } from '../../office-products/dtos/office-product-assignment.lite.dto.js';
import { UserResponseDto } from './user.response.dto.js';
/**
 * User DTO for patient list views.
 * Extends UserResponseDto with cross-context data needed for the patient list
 * (office product assignment counters for training status display).
 */
export class PatientForListUserDto extends UserResponseDto {
    officeProductAssignments = [];
}
__decorate([
    Expose(),
    Type(() => OfficeProductAssignmentLiteDto),
    __metadata("design:type", Array)
], PatientForListUserDto.prototype, "officeProductAssignments", void 0);
//# sourceMappingURL=patient-for-list-user.dto.js.map